import { IonContent, IonHeader, IonPage, IonTitle, IonToolbar} from '@ionic/react';
import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import './css/general.css';
import styles from './css/Score.module.css';
import axiosInstance from '../services/AxiosInstance';


interface ScoreProps extends RouteComponentProps {
  // Define the props here
}
interface ScoreState {
  // Define the state here
  userSubjects: UserSubject[];
}

export interface UserSubjectInterface {
  subjectId: number,
  subjectName: string,
  challengeIds: number[],
  completedChallenges: number[],
  notCompletedChallenges: number[],
  notParticipatedChallenges: number[],
  subjectScore: number,
  subjectMaxScore: number,
}

export class UserSubject implements UserSubjectInterface {
  subjectId: number;
  subjectName: string;
  challengeIds: number[];
  completedChallenges: number[];
  notCompletedChallenges: number[];
  notParticipatedChallenges: number[];
  subjectScore: number;
  subjectMaxScore: number;

  constructor(subjectId: number, subjectName: string, challengeIds: number[], completedChallenges: number[], notCompletedChallenges: number[],notParticipatedChallenges: number[], subjectScore: number, subjectMaxScore: number) {
    this.subjectId = subjectId;
    this.subjectName = subjectName;
    this.challengeIds = challengeIds;
    this.completedChallenges = completedChallenges;
    this.notCompletedChallenges = notCompletedChallenges;
    this.notParticipatedChallenges = notParticipatedChallenges;
    this.subjectScore = subjectScore;
    this.subjectMaxScore = subjectMaxScore;
  }

}

class ScorePage extends React.Component<ScoreProps, ScoreState>{
  constructor(props: ScoreProps) {
    super(props);

    this.state = {
      userSubjects: [],
    }

    this.getSubjects();
  }

  async getSubjects() {
    const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    let subjects: any[] = []
    
    axiosInstance
    .get("/UserSubjects/" + id, config)
    .then((resp) => {
      //console.log(resp.data)
     resp.data.forEach((subject: any) => {
       subjects.push({
         subjectId: subject.subjectId,
         subjectName: subject.subject.subjectName
       })
      });
        this.getChallenges(subjects)
      })
      .catch((error) => {
        console.log(error);
      });
  }


  async getChallenges(subjects: any[]) {
    const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };
    for(const subject of subjects) {
      let challenges: any[] = []
      
      await axiosInstance.get("/UserChallenges/" + id + "/AllSubjects/" + subject.subjectId, config)
      .then((res) => {
        //console.log(res.data)
        res.data.forEach((challenge: any) => {
          challenges.push({
            challengeId: challenge.challengeId,
            challengeTitle: challenge.challenge.title
          })
        })
      })
      subject.subjectChallenges = challenges
    }
    this.getParticipatedChallenges(subjects)
  }
  
  async getParticipatedChallenges(subjects: any[]) {
    const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    for(const subject of subjects) {
      let completed: number[] = []
      let notCompleted: number[] = []
      let notParticipated: number[] = []
      let challengeIds = subject.subjectChallenges
      //console.log(challengeIds)

      for(const challenge of challengeIds) {
        await axiosInstance.get("/Results/Employee/" + id + "/Challenges/" + challenge.challengeId, config)
        .then((res) => {
          //console.log(res.data)
          let challenges = res.data
          if(challenges != undefined) {
            challenge.challengeResult = challenges.score
            if(challenges.score >= 0) {
              completed.push(challenges.challengeId)
            } else if(challenges.score == -1) {
              notCompleted.push(challenges.challengeId)
            }
          }
          if(!completed.includes(challenge.challengeId) && !notCompleted.includes(challenge.challengeId)){
            notParticipated.push(challenge.challengeId)
            // score = -2 if not participated
            challenge.challengeResult = -2
          }
        })
      }
      subject.completedChallenges = completed
      subject.notCompletedChallenges = notCompleted
      subject.notParticipatedChallenges = notParticipated

    }
    this.getScorePerChallenge(subjects)
  }

  async getScorePerChallenge(subjects: any[]){
  //console.log(subjects)
   const token = localStorage.getItem("token");
    var id = localStorage.getItem("id");
    const config = {
      headers: {
        Authorization: "Bearer " + token,
      },
    };

    for(const subject of subjects) {
      let challenges = subject.subjectChallenges

      for(const challenge of challenges){
        await axiosInstance.get("/Challenges/" + challenge.challengeId, config)
        .then((res) => {
          //console.log(res.data)
          challenge.amountOfQuestions = res.data.questions.length
          if(challenge.challengeResult != -1 && challenge.challengeResult != -2) {
            if(challenge.challengeResult <= res.data.questions.length / 2 && challenge.challengeResult != 0) {
                challenge.score = challenge.challengeResult - 1
              } else {
                challenge.score = challenge.challengeResult
              }
            } else {
              challenge.score = 0
            }
        })        
      }
    }
    this.getScorePerSubject(subjects)
  }

  async getScorePerSubject(subjects: any[]) {
    
    subjects.forEach((subject) => {
      let score: number = 0
      let max: number = 0
      let challenges = subject.subjectChallenges
      challenges.forEach((challenge: any) => {
        score += challenge.score
        max += challenge.amountOfQuestions
      })
      subject.subjectScore  = score
      subject.subjectMaxScore  = max
    })
    //console.log(subjects)
    this.setState({userSubjects: subjects})
  }


  async GoToScorePage(subject : UserSubject)
  {
    localStorage.setItem("Sub", JSON.stringify(subject));

    const { history } = this.props;
    history.push("/Score");
  }

  render() {
    return (
      <IonPage>
        <IonHeader class="ion-no-border">
          <IonToolbar>
          <button className="backButton" onClick={() => {this.props.history.goBack()}}>&larr;</button>
            <IonTitle>Score</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <div className={styles.subjects}>
          {this.state.userSubjects.map((subject) => (
                <div
                  key={subject.subjectId}
                  className={styles.panel}
                  onClick={() => {this.GoToScorePage(subject)}}
                >
                    <div className={styles.flex}>
                      <p className={styles.text}>{subject.subjectName}</p>
                      <p className={styles.subjectScore}>{subject.subjectScore}</p>
                    </div>
                  <p className={styles.info}> Klik voor meer details</p>
                </div>
          ))}
          </div>

        </IonContent>
      </IonPage>
    );
  }
};

export default withRouter(ScorePage)
